<div class="card-container">
    <div class="header">
        <img src="assets/images/mern-logo.svg">
        <h1>{{ 'sigt.integration.rapportCommentaires.card.title' | translate }} {{pageTitle}}</h1>
    </div>
    <div class="data">
        <div>
            <h2>{{ 'sigt.integration.rapportCommentaires.card.subtitle01' | translate }}</h2>
            <table>
                <tr>
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.date' | translate }}</th>
                    <td>{{ commentaire.date }}</td>
                </tr>
                <tr>
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.auteur' | translate }}</th>
                    <td>{{ commentaire.auteur }}</td>
                </tr>
                <tr>
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.courriel' | translate }}</th>
                    <td>{{ commentaire.ADR_COURR_UTILISATEUR }}</td>
                </tr>
                <tr *ngIf="commentaire.CODE_UTILISATEUR">
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.codeUtilisateur' | translate }}</th>
                    <td>{{ commentaire.CODE_UTILISATEUR }}</td>
                </tr>
                <tr *ngIf="commentaire.TYPE_PLAN">
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.typePlan' | translate }}</th>
                    <td>{{ commentaire.TYPE_PLAN }}</td>
                </tr>
                <tr>
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.longitude' | translate }}</th>
                    <td>{{ commentaire.longitude }}</td>
                </tr>
                <tr>
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.latitude' | translate }}</th>
                    <td>{{ commentaire.latitude }}</td>
                </tr>
                <tr>
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.region' | translate }}</th>
                    <td>{{ commentaire.NO_REGION }}</td>
                </tr>
                <tr *ngIf="commentaire.typeAvis">
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.typeAvis' | translate }}</th>
                    <td>{{ commentaire.typeAvis }}</td>
                </tr>
                <tr *ngIf="commentaire.typeAvis">
                    <th>{{ 'sigt.integration.rapportCommentaires.grid.objet' | translate }}</th>
                    <td>{{ commentaire.objet }}</td>
                </tr>
                <tr>
                    <th colspan="2">{{ 'sigt.integration.rapportCommentaires.grid.commentaire' | translate }}</th>
                </tr>
                <tr>
                    <td colspan="2">{{ commentaire.COMMENTAIRE }}</td>
                </tr>
            </table>
        </div>
        <div>
            <h2>{{ 'sigt.integration.rapportCommentaires.card.subtitle02' | translate }}</h2>
            <igo-map-browser [map]="map"></igo-map-browser>
        </div>
    </div>
</div>